import { useI18N } from "../context/I18NContext";
export const createRow = (desc, unit, qty, vatrate, type, origin) => {
    let price = priceRow(qty !== null && qty !== void 0 ? qty : 1, unit !== null && unit !== void 0 ? unit : 0);
    return {
        desc: desc,
        unit: unit !== null && unit !== void 0 ? unit : 0,
        qty: qty !== null && qty !== void 0 ? qty : 1,
        price: price,
        vatrate: vatrate,
        type: type,
        origin: origin
    };
};
export const subtotal = (items) => {
    return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
};
export const moneyFormat = (num) => {
    return `€ ${num.toFixed(2).replace('.', ',')}`.replace(',00', ',-');
};
export const durationFormat = (duration) => {
    const { t } = useI18N();
    let parts = duration.split(' '), amount = parseInt(parts[0]), unit = parts[1], units = {
        day: t(amount === 1 ? 'dag' : 'dagen', 'general'),
        week: t(amount === 1 ? 'week' : 'weken', 'general'),
        month: t(amount === 1 ? 'maand' : 'maanden', 'general'),
        year: t(amount === 1 ? 'jaar' : 'jaar', 'general'),
    };
    //@ts-ignore
    return `${parts[0]} ${units[unit]}`;
};
export const priceRow = (qty, unit) => {
    return qty * unit;
};
